import React, { Component } from 'react';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import { Redirect } from 'react-router-dom';
import { EditorState, convertToRaw } from 'draft-js';

import Header from './header';
import Editor from './editor';
import * as commonActions from '../common/actions'
import * as mailActions from './actions';
import {fetchTemplates, setTemplatesList} from '../communication-templates/list/actions';
import './mail-composer.css';

const Alerts = require ('../alerts');

class MailComposer extends Component {
  constructor (props) {
    super(props);

    this.state ={
      lastVisitedHiringClientUpdated: false,
      lastVisitedSubcontractorUpdated: false,
      forceUpdate: props.forceUpdate,
    };

    this.onSendMail = this.onSendMail.bind(this);
    this.onDiscardMail = this.onDiscardMail.bind(this);

    props.commonActions.fetchUserHiringClients(this.props.system);
  }

  async componentWillReceiveProps(nextProps) {
    if (this.props.mailComposer.sendingMail && !nextProps.mailComposer.sendingMail) {
      if (nextProps.mailComposer.errorMsg) {
        Alerts.showInformationAlert(
          'Error',
          nextProps.mailComposer.errorMsg,
          'Accept',
          false,
          ()=>{}
        );
      } else if(nextProps.mailComposer.successMsg) {
        Alerts.showInformationAlert(
          'Success',
          nextProps.mailComposer.successMsg,
          'Accept',
          false,
          ()=>{
            this.onDiscardMail();
          }
        );
      }
    }
    const lastHiringClientIdVisited = this.props.common.lastHiringClientId;
    const lastSubcontractorVisited = this.props.common.lastSubcontractorId || '';

    let newHC = nextProps.mailComposer.hiringClientId;
    const oldHC = this.props.mailComposer.hiringClientId;
    let newSC = nextProps.mailComposer.subcontractorId;
    const oldSC = this.props.mailComposer.subcontractorId;

    let newProject = nextProps.mailComposer.projectId;
    const oldProject = this.props.mailComposer.projectId;
    if (oldProject !== newProject) {
      this.props.actions.setMailProject(newProject);
    }

    if (lastHiringClientIdVisited && !this.state.lastVisitedHiringClientUpdated) {
      newHC = lastHiringClientIdVisited;
    }

    const {insuredId, recipients,templateId, projectId} = this.props.mailData;

    if ((newHC !== oldHC) || (newSC !== oldSC)) {
      if (newHC === ""){
        this.props.actions.setPossibleRecipeints([]);
        this.props.actions.setMailPossibleSubcontractors([]);
      } else {
        if ( (newHC !== oldHC || (this.state.forceUpdate))) {
          this.setState({
            forceUpdate: false,
          })
          newSC = '';

          if (this.state.lastVisitedHiringClientUpdated && !this.state.lastVisitedSubcontractorUpdated) {
            newSC = lastSubcontractorVisited;
            this.setState({ lastVisitedSubcontractorUpdated: true });

          }
          this.props.actions.setMailHiringClientId(newHC)

          if (recipients) {
            this.props.actions.setMailTo(recipients);
            //todo: override emails here.
          }

          this.props.actions.setMailSubcontractorId(newSC);
          await this.props.actions.fetchPossibleSubcontractors(newHC)
            .then ( response => {
              if (insuredId) {
                this.props.actions.setMailSubcontractorId(insuredId, this.props.templates.list)
              }
            })
          await this.props.actions.fetchPossibleProjects(newHC)
            .then(response => {
              if (projectId) {
                this.props.actions.setMailProject(projectId);
              }
            })
          this.props.fetchTemplates({
            orderBy: 'templateName',
            orderDirection: 'ASC',
            hiringClientId: newHC,
            isBehalfHC: true
          }).then(response => {
              if (templateId) {
                  this.props.actions.setMailTemplate(templateId, this.props.templates.list)
              }else{
                let mailTemplateId =  this.props.mailComposer.template.id
                this.props.actions.setMailTemplate(mailTemplateId, this.props.templates.list)
              }
          });
        }
        this.props.actions.fetchPossibleRecipeints(newHC, newSC);
      }
    }

    this.setState({ lastVisitedHiringClientUpdated: true })
  }

  componentWillUnmount () {
    this.onDiscardMail();
  }

  onSendMail () {
    // create the id list
    let emailsList = "";
    if (this.props.mailComposer.recipients.length > 0) {
      const recipients = this.props.mailComposer.recipients;
      for (var i = 0; i < recipients.length; i++) {
        if(emailsList === "")
          emailsList += recipients[i].id;
        else
          emailsList += `,${recipients[i].id}`;
      }
    } else if (this.props.mailComposer.mailTo != '') {
      emailsList = this.props.mailComposer.mailTo
    }

    const {certificateId} = this.props.mailData;

    if (emailsList !== "") {
      const payload = {
        emailsList,
        subject: this.props.mailComposer.mail.subject,
        body: this.props.mailComposer.mail.bodyHTML.replace(/\udcf7/g, ''),
        hiringClientId: this.props.mailComposer.hiringClientId,
        subcontractorId: this.props.mailComposer.subcontractorId,
        dueDate: this.props.mailComposer.dueDate,
        taskDetail: this.props.mailComposer.taskDetail,
        projectId: this.props.mailComposer.project,
        system: this.props.login.currentSystem,
        templateId:this.props.mailComposer.template.id,
        certificateId: certificateId
      };
      this.props.actions.sendMail(payload);
    }
  }

  onDiscardMail () {
    const editorState = EditorState.createEmpty();
    const text = JSON.stringify(convertToRaw(editorState.getCurrentContent()));
    this.props.actions.setMailEditorState(editorState, text);
    this.props.actions.setMailSubject("");
    this.props.actions.setMailRecipeints([]);
    this.props.actions.setPossibleRecipeints([]);
    this.props.actions.setMailHiringClientId("");
    this.props.actions.setMailPossibleSubcontractors([]);
    this.props.actions.setMailPossibleProjects([]);
    this.props.setTemplatesList([]);
    this.props.actions.setMailTemplate([], {});
    this.props.actions.setMailSubcontractorId("");
    this.props.actions.setMailDueDate("");
    this.props.actions.setMailTaskDetail("");
    this.props.actions.setMailTo('');
  }

  render() {
    const {
      sendBtn,
      discardBtn
    } = this.props.local.strings.mailComposer;
    return(
      <div className="container-fluid mail-composer">
            <div>
              <Header
                mailData = {this.props.mailData}
                setMailHiringClientId={this.props.actions.setMailHiringClientId}
                setMailRecipeints={this.props.actions.setMailRecipeints}
                setMailSubject={this.props.actions.setMailSubject}
                setMailSubcontractorId={this.props.actions.setMailSubcontractorId}
                setMailDueDate={this.props.actions.setMailDueDate}
                setMailTaskDetail={this.props.actions.setMailTaskDetail}
                system={this.props.system}
              />
              <Editor setMailEditorState={this.props.actions.setMailEditorState}/>
              <div className="mailFooter">
                <div className="column">
                </div>
                <div className="mailFooterRow">
                  <button className="footerBtn" onClick={this.onSendMail}>{sendBtn}</button>
                  <button className="footerBtn" onClick={this.onDiscardMail}>{discardBtn}</button>
                </div>
              </div>
            </div>
      </div>
    );
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    actions: bindActionCreators(mailActions, dispatch),
    commonActions: bindActionCreators(commonActions, dispatch),
    fetchTemplates: bindActionCreators(fetchTemplates, dispatch),
    setTemplatesList: bindActionCreators(setTemplatesList, dispatch),
  };
};

const mapStateToProps = (state, ownProps) => {
  const { login, mailComposer, common, localization, templates } = state;
  return {
    login,
    mailComposer,
    common,
    templates,
    local: localization
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(MailComposer);
